import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import './Login.css';

const ForgotPassword = () => {
    const [step, setStep] = useState(1); // 1: email, 2: token + new password
    const [email, setEmail] = useState('');
    const [resetToken, setResetToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleRequestToken = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);

        try {
            const response = await authService.forgotPassword(email);
            if (response.success) {
                // Clear success message before moving to step 2
                setSuccess('');
                setStep(2);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error al solicitar código de recuperación');
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        // Validations
        if (newPassword.length < 8) {
            setError('La contraseña debe tener al menos 8 caracteres');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('Las contraseñas no coinciden');
            return;
        }

        setLoading(true);

        try {
            const response = await authService.resetPassword(email, resetToken, newPassword);
            if (response.success) {
                setSuccess('Contraseña restablecida exitosamente. Redirigiendo al login...');
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error al restablecer la contraseña');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="login-header">
                    <h1>CENTRO OFTALMOLÓGICO</h1>
                    <h2>LOS DOS CAMINOS</h2>
                    <p>Recuperación de Contraseña</p>
                </div>

                {step === 1 ? (
                    <form onSubmit={handleRequestToken} className="login-form">
                        {error && <div className="alert alert-error">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="correo@ejemplo.com"
                                disabled={loading}
                            />
                            <small style={{ color: '#666', fontSize: '0.85rem', marginTop: '0.25rem' }}>
                                Ingrese el email con el que se registró en el sistema
                            </small>
                        </div>

                        <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                            {loading ? 'Enviando código...' : 'Enviar Código al Email'}
                        </button>

                        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                            <button
                                type="button"
                                onClick={() => navigate('/login')}
                                className="btn-link"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#5f91c5',
                                    cursor: 'pointer',
                                    textDecoration: 'underline'
                                }}
                            >
                                Volver al login
                            </button>
                        </div>
                    </form>
                ) : (
                    <form onSubmit={handleResetPassword} className="login-form">
                        {error && <div className="alert alert-error">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}

                        <div className="info-box" style={{
                            backgroundColor: '#e8f4f8',
                            border: '1px solid #5f91c5',
                            borderRadius: '4px',
                            padding: '1rem',
                            marginBottom: '1rem'
                        }}>
                            <p style={{ margin: 0, fontSize: '0.9rem', color: '#1d2d48' }}>
                                <strong>📧 Código enviado a su correo electrónico</strong><br />
                                Hemos enviado un código de 8 caracteres a <strong>{email}</strong>. Por favor revise su bandeja de entrada (y la carpeta de spam) e ingréselo a continuación junto con su nueva contraseña.
                            </p>
                        </div>

                        <div className="form-group">
                            <label htmlFor="resetToken">Código de Recuperación *</label>
                            <input
                                type="text"
                                id="resetToken"
                                value={resetToken}
                                onChange={(e) => setResetToken(e.target.value)}
                                required
                                placeholder="Ingrese el código de 8 caracteres"
                                disabled={loading}
                                maxLength={8}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="newPassword">Nueva Contraseña *</label>
                            <input
                                type="password"
                                id="newPassword"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                                placeholder="Mínimo 8 caracteres"
                                disabled={loading}
                                minLength={8}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirmar Contraseña *</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                placeholder="Repita la contraseña"
                                disabled={loading}
                            />
                        </div>

                        <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                            {loading ? 'Restableciendo...' : 'Restablecer Contraseña'}
                        </button>

                        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                            <button
                                type="button"
                                onClick={() => {
                                    setStep(1);
                                    setResetToken('');
                                    setNewPassword('');
                                    setConfirmPassword('');
                                    setError('');
                                    setSuccess('');
                                }}
                                className="btn-link"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#5f91c5',
                                    cursor: 'pointer',
                                    textDecoration: 'underline'
                                }}
                            >
                                Solicitar nuevo código
                            </button>
                        </div>
                    </form>
                )}

                <div className="login-footer">
                    <p>© 2025 Centro Oftalmológico Los Dos Caminos</p>
                    <p>RIF: J-50692449-8</p>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
